import React from 'react';
import moment from "moment";
import pull = require("lodash/pull");
import {MdTextField} from 'core/components/fields/fields';
import {lovLabel, FieldText, ClosedContentProps, FormProps, lovValue} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {PartyFeature, Party, ADDRESSPLACETYPE} from "party/partyDomain";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {PROFITCENTER} from "product/productDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import StyledSelect from "core/components/fields/styledSelect";
import {optionsSearch} from "core/common/service/commonDataService";
import securityService from "core/security/securityService";
import shipmentService from "shipment/shipmentService";
import {LovItem} from "core/metamodel/mdEntity";
import {ShipmentVisit} from "shipment/shipmentDomain";
import MdEntityService from "core/metamodel/mdEntityService";





/* ************************************************************************************************
 * ***********   INVOICE_DATAForm *************************************************************
 * ********************************************************************************************** */


const INVOICE_DATAFormName = 'INVOICE_DATAForm';


// tslint:disable-next-line:class-name
interface INVOICE_DATAFormIntf extends PartyFeature {
  accountingMatchingId: string;
  invoiceDateDelay: string;
  customerMatchingId: string;
  customerMatchingId2: string;
  invoicingPeriod: string;
  invoicingStartDate: string|Date;
  tradingPartner: string;
}

const INVOICE_DATAClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<INVOICE_DATAFormIntf>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <div className="form-text-row">
      <FieldText label={fields.accountingMatchingId.textLabel} value={dataObject.value1}/>
      <FieldText label={fields.invoiceDateDelay.textLabel} value={dataObject.value2} mdField={fields.invoiceDateDelay.mdField}/>
      <FieldText label={fields.customerMatchingId.textLabel} value={dataObject.value3}/>
      <FieldText label={fields.customerMatchingId2.textLabel} value={dataObject.value6}/>
      <FieldText label={fields.invoicingPeriod.textLabel} value={dataObject.value4} mdField={fields.invoicingPeriod.mdField}/>
      <FieldText label={fields.invoicingStartDate.textLabel} value={dataObject.value5} mdField={fields.invoicingStartDate.mdField}/>
      <FieldText label={fields.tradingPartner.textLabel} value={dataObject.value7}/>
    </div>
  </div>
);

@createForm({
  formName: INVOICE_DATAFormName,
  fields: [{
    name: 'accountingMatchingId',
    validators: ['IsRequired', 'IsNumber', {validation: 'HasLength', parameters: {max : 10}}],
    setFieldValueFn: (dataObject, value) => dataObject.value1 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value1
  },{
    name: 'invoiceDateDelay',
    setFieldValueFn: (dataObject, value) => dataObject.value2 = lovValue(value),
    getFieldValueFn: (dataObject) => dataObject.value2
  },{
    name: 'customerMatchingId',
    setFieldValueFn: (dataObject, value) => dataObject.value3 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value3
  },{
    name: 'invoicingPeriod',
    setFieldValueFn: (dataObject, value) => dataObject.value4 = lovValue(value),
    getFieldValueFn: (dataObject) => dataObject.value4
  },{
    name: 'invoicingStartDate',
    setFieldValueFn: (dataObject, value) => dataObject.value5 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value5
  },{
    name: 'customerMatchingId2',
    setFieldValueFn: (dataObject, value) => dataObject.value6 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value6
  },{
    name: 'tradingPartner',
    setFieldValueFn: (dataObject, value) => dataObject.value7 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value7
  }
  ]
}, INVOICE_DATAClosedContent)
@observer
export class INVOICE_DATAForm extends React.Component<FormProps<INVOICE_DATAFormIntf, Party>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.features, this.props.dataObject);
  };


  render() {

    const {dataObject, rootObject, index, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {accountingMatchingId, invoiceDateDelay, customerMatchingId, invoicingPeriod, invoicingStartDate, customerMatchingId2, tradingPartner} = fields;

    const iddValues = ["P1M", "P2M", "P3M", "P4M", "P5M", "P6M", "P7M", "P8M", "P9M", "P10M", "P11M", "P1Y"];

    const iddOptions = [{value: null, label: '---'}, ...iddValues.map(v => ({value: v, label: moment.duration(v).humanize()})) ];

    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...accountingMatchingId.props} />
            <Validate field={accountingMatchingId} value={accountingMatchingId.props.value} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...invoiceDateDelay.props} searchable={false} clearable={false} options={iddOptions} />
            <Validate field={invoiceDateDelay} value={invoiceDateDelay.props.value} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...customerMatchingId.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...invoicingPeriod.props} searchable={false} clearable={false} options={iddOptions} />
            <Validate field={invoicingPeriod} value={invoicingPeriod.props.value} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <StyledDatePicker {...invoicingStartDate.props} />
            <Validate field={invoicingStartDate} value={invoicingStartDate.props.value} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...customerMatchingId2.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...tradingPartner.props} />
          </div>
        </div>
      </div>


    );


    return (
      <ActiveItem openContent={openContent}
                  closedContent={<INVOICE_DATAClosedContent {...{ dataObject, entity, entities, fields }} />}
                  key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}


/* ************************************************************************************************
 * ***********   VOLVO_LOGINSForm *************************************************************
 * ********************************************************************************************** */


const VOLVO_LOGINSFormName = 'VOLVO_LOGINSForm';

interface VOLVO_LOGINSFormIntf extends PartyFeature {
  adminLoginDF: string;
  adminPasswordDF: string;
  adminLoginOF: string;
  adminPasswordOF: string;
  userLoginDF: string;
  userPasswordDF: string;
  userLoginOF: string;
  userPasswordOF: string;
  fuelCheckLogin: string;
  fuelCheckPassword: string;
  volvoLogin: string;
  renaultLogin: string;
}

// * 1:  adminLoginDF
// * 2:  adminPasswordDF
// * 3:  adminLoginOF
// * 4:  adminPasswordOF
// * 5:  userLoginDF
// * 6:  userPasswordDF
// * 7:  userLoginOF
// * 8:  userPasswordOF
// * 9:  fuelCheckLogin
// * 10: fuelCheckPassword
// * 11: volvoLogin
// * 12: renaultLogin


const VOLVO_LOGINSClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<VOLVO_LOGINSFormIntf>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <div className="form-text-row">
      <FieldText label={fields.adminLoginDF.textLabel} value={dataObject.value1}/>
      <FieldText label={fields.adminPasswordDF.textLabel} value={dataObject.value2}/>
      <FieldText label={fields.adminLoginOF.textLabel} value={dataObject.value3}/>
      <FieldText label={fields.adminPasswordOF.textLabel} value={dataObject.value4}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.userLoginDF.textLabel} value={dataObject.value5}/>
      <FieldText label={fields.userPasswordDF.textLabel} value={dataObject.value6}/>
      <FieldText label={fields.userLoginOF.textLabel} value={dataObject.value7}/>
      <FieldText label={fields.userPasswordOF.textLabel} value={dataObject.value8}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.fuelCheckLogin.textLabel} value={dataObject.value9}/>
      <FieldText label={fields.fuelCheckPassword.textLabel} value={dataObject.value10}/>
      <FieldText label={fields.volvoLogin.textLabel} value={dataObject.value11}/>
      <FieldText label={fields.renaultLogin.textLabel} value={dataObject.value12}/>
    </div>
  </div>
);



@createForm({
  formName: VOLVO_LOGINSFormName,
  fields: [{
    name: 'adminLoginDF',
    setFieldValueFn: (dataObject, value) => dataObject.value1 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value1
  }, {
    name: 'adminPasswordDF',
    setFieldValueFn: (dataObject, value) => dataObject.value2 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value2
  }, {
    name: 'adminLoginOF',
    setFieldValueFn: (dataObject, value) => dataObject.value3 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value3
  }, {
    name: 'adminPasswordOF',
    setFieldValueFn: (dataObject, value) => dataObject.value4 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value4
  }, {
    name: 'userLoginDF',
    setFieldValueFn: (dataObject, value) => dataObject.value5 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value5
  }, {
    name: 'userPasswordDF',
    setFieldValueFn: (dataObject, value) => dataObject.value6 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value6
  }, {
    name: 'userLoginOF',
    setFieldValueFn: (dataObject, value) => dataObject.value7 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value7
  }, {
    name: 'userPasswordOF',
    setFieldValueFn: (dataObject, value) => dataObject.value8 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value8
  }, {
    name: 'fuelCheckLogin',
    setFieldValueFn: (dataObject, value) => dataObject.value9 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value9
  }, {
    name: 'fuelCheckPassword',
    setFieldValueFn: (dataObject, value) => dataObject.value10 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value10
  }, {
    name: 'volvoLogin',
    setFieldValueFn: (dataObject, value) => dataObject.value11 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value11
  }, {
    name: 'renaultLogin',
    setFieldValueFn: (dataObject, value) => dataObject.value12 = value,
    getFieldValueFn: (dataObject) => dataObject.value12
  }]
}, VOLVO_LOGINSClosedContent)
@observer
export class VOLVO_LOGINSForm extends React.Component<FormProps<VOLVO_LOGINSFormIntf, Party>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.features, this.props.dataObject);
  };

  @action onVolvoLoginEnable = (value) => {
    return !value;
  };

  @action onVolvoLogin = (evt) => {
    evt.preventDefault();
    let {dataObject, rootObject, form} = this.props;
    mdEntityService.fetchNextEntityNumber("PartyFeature_VOLVO_LOGINS", null, PROFITCENTER.DYNAFLEET, null)
      .then(action("fetchNextEntityNumber-actionCb", (entityNumber: string) => {
        if (entityNumber) {
          dataObject.value11 = entityNumber;
          form.updateFieldsPropValue(dataObject, "volvoLogin")
          rootObject.$dirty = true;
        }
      }));
  };

  @action onRenaultLogin = (evt) => {
    evt.preventDefault();
    let {dataObject, rootObject, form} = this.props;
    mdEntityService.fetchNextEntityNumber("PartyFeature_VOLVO_LOGINS", null, PROFITCENTER.OPTIFLEET, null)
      .then(action("fetchNextEntityNumber-actionCb", (entityNumber: string) => {
        if (entityNumber) {
          dataObject.value12 = entityNumber;
          form.updateFieldsPropValue(dataObject, "renaultLogin");
          rootObject.$dirty = true;
        }
      }));
  };


  render() {


    const {dataObject, rootObject, index, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {adminLoginDF, adminPasswordDF, adminLoginOF, adminPasswordOF, userLoginDF, userPasswordDF, userLoginOF, userPasswordOF, fuelCheckLogin, fuelCheckPassword, volvoLogin, renaultLogin} = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...adminLoginDF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...adminPasswordDF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...adminLoginOF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...adminPasswordOF.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...userLoginDF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...userPasswordDF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...userLoginOF.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...userPasswordOF.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...fuelCheckLogin.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...fuelCheckPassword.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...volvoLogin.props} showValidationIcon={true} onAction={this.onVolvoLogin}
                         onActionEnable={this.onVolvoLoginEnable}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...renaultLogin.props} showValidationIcon={true} onAction={this.onRenaultLogin}
                         onActionEnable={this.onVolvoLoginEnable}/>
          </div>
        </div>
      </div>
    );

    return (
      <ActiveItem openContent={openContent}
                  closedContent={<VOLVO_LOGINSClosedContent {...{dataObject, entity, entities, fields}} />}
                  key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}

  /* ************************************************************************************************
 * ***********   AUTONEUM_DATAForm *************************************************************
 * ********************************************************************************************** */


  const AUTONEUM_DATAFormName = 'AUTONEUM_DATAForm';

  interface AUTONEUM_DATAFormIntf extends PartyFeature {
    disponentNumber: string;
    defaultShippedFromPlace: string;
    defaultShippedToPlace: string;
  }

// * 1:  disponentNumber


const AUTONEUM_DATAClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<AUTONEUM_DATAFormIntf>) => {

  let addressPlaceMdEntity = MdEntityService.getEntity("AddressPlace");
  let defaultShippedFromPlace = (dataObject.value2) ? addressPlaceMdEntity.getLovItem(dataObject.value2, false) : null;
  let defaultShippedToPlace = (dataObject.value3) ? addressPlaceMdEntity.getLovItem(dataObject.value3, false) : null;

    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div className="form-text-row">
          <FieldText label={fields.disponentNumber.textLabel} value={dataObject.value1}/>
          <FieldText label={fields.defaultShippedFromPlace.textLabel} value={defaultShippedFromPlace}/>
          <FieldText label={fields.defaultShippedToPlace.textLabel} value={defaultShippedToPlace}/>
        </div>
      </div>
    )
} ;



@createForm({
  formName: AUTONEUM_DATAFormName,
  fields: [{
    name: 'disponentNumber',
    setFieldValueFn: (dataObject, value) => dataObject.value1 = (value === '') ? null : value,
    getFieldValueFn: (dataObject) => dataObject.value1
  },
    {
      name: 'defaultShippedFromPlace',
      setFieldValueFn: (dataObject, value) => dataObject.value2 = lovValue(value),
      getFieldValueFn: (dataObject) => dataObject.value2
    },
    {
      name: 'defaultShippedToPlace',
      setFieldValueFn: (dataObject, value) => dataObject.value3 = lovValue(value),
      getFieldValueFn: (dataObject) => dataObject.value3
    }]
}, AUTONEUM_DATAClosedContent)

@observer
export class AUTONEUM_DATAForm extends React.Component<FormProps<AUTONEUM_DATAFormIntf, Party>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.features, this.props.dataObject);
  };

  componentDidMount() {
    return this.populateDropdowns(true);
  }

  componentDidUpdate() {
    let {form, dataObject} = this.props;
    let defaultShippedFromPlaceField = form.getField("defaultShippedFromPlace");
    let defaultShippedToPlaceField = form.getField("defaultShippedToPlace");


    if (
      (defaultShippedToPlaceField && (!defaultShippedToPlaceField.props.options || !defaultShippedToPlaceField.props.options.length) )
      || (defaultShippedFromPlaceField && (!defaultShippedFromPlaceField.props.options || !defaultShippedFromPlaceField.props.options.length) )
    ) {
      console.debug("componentDidUpdate, no dropdown data filling");
      return this.populateDropdowns(false);
    }
  }


  private populateDropdowns(initial: boolean) {
    let {dataObject, form} = this.props;

    return (Promise.all([
      optionsSearch('AddressPlace', {
        partyId: securityService.currentTenant.party.value,
        placeType: ADDRESSPLACETYPE.EXPEDITION
      }), optionsSearch('AddressPlace', {
        partyId: securityService.currentTenant.party.value,
        placeType: ADDRESSPLACETYPE.INCOMING
      })]))
      .then(action("populateDropdowns-action", ([{options: fromPlaceOptions}, {options: toPlaceOptions}]: [{ options: LovItem[] }, { options: LovItem[] }]) => {
        fromPlaceOptions.unshift({value: null, label: '---'});
        toPlaceOptions.unshift({value: null, label: '---'});
        form.getField("defaultShippedFromPlace").props.options = observable.shallowArray(fromPlaceOptions);
        form.getField("defaultShippedToPlace").props.options = observable.shallowArray(toPlaceOptions);
        form.updateFieldsPropValue(dataObject, "defaultShippedFromPlace", "defaultShippedToPlace");
      }));
  }


  render() {

    const {dataObject, rootObject, index, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {disponentNumber, defaultShippedFromPlace, defaultShippedToPlace} = fields;


    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...disponentNumber.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-6">
            <StyledSelect {...defaultShippedFromPlace.props} clearable={false} />
          </div>
          <div className="fx col-xs-6">
            <StyledSelect {...defaultShippedToPlace.props}  clearable={false} />
          </div>
        </div>
      </div>
    );

    return (
      <ActiveItem openContent={openContent} closedContent={<AUTONEUM_DATAClosedContent {...{dataObject, entity, entities, fields}} />}
                  key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}




// WEBPACK FOOTER //
// ./src/party/component/partyFeatures.tsx